import { Component, Input, OnDestroy, OnInit, ChangeDetectorRef } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import moment from 'moment-timezone';
import { Moment } from 'moment-timezone';
import { Subscription } from 'rxjs/internal/Subscription';
import { DataTypeComponent } from '../../../data-type-component';
import { FieldConfigDTO } from '../../../../../../system/system-dtos';
import { MyErrorStateMatcher, ValidatorConfig } from '../../../../../../common/field-validation/my-error-state-matcher';
import { UiValidator } from '../../../../../../common/field-validation/ui-validator.dto';
import { SystemService } from '../../../../../../system/system.service';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';

const DATE_FORMATS = {
  parse: { dateInput: 'DD/MM/YYYY' },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-form-field-date-time',
  templateUrl: './date-time-form-field.component.html',
  styleUrls: ['./date-time-form-field.component.scss'],
  standalone: false,
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: DATE_FORMATS },
  ],
})
export class DateTimeFormFieldComponent extends DataTypeComponent implements OnDestroy, OnInit {
  @Input() formGroup: UntypedFormGroup;

  @Input() fieldConfig: FieldConfigDTO;

  @Input() data: any;

  @Input() editMode: boolean;

  @Input() datePlaceholder: string = 'Date';

  @Input() timePlaceholder: string = 'Time';

  public dateFormat = 'YYYY-MM-DDTHH:mm:ss.SSSZ';

  public saveDateFormat = 'YYYY-MM-DDTHH:mm:ss.SSSZ';

  public modelDate: Moment;

  public modelTime: string;

  matcher = new MyErrorStateMatcher();

  public timezone: string;

  public formattedDate: string;

  public timezoneSubscription: Subscription;
  private controlClearSubscription: Subscription;

  private entity: string;

  editReadOnly: boolean = false;

  constructor(
    private systemService: SystemService,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    super();
  }

  ngOnDestroy() {
    if (this.timezoneSubscription) {
      this.timezoneSubscription.unsubscribe();
    }
    if (this.controlClearSubscription) {
      this.controlClearSubscription.unsubscribe();
    }
  }

  ngOnInit(): void {
    this.systemService.systemTimeZoneSubject.subscribe((timezone: string) => {
      this.timezone = timezone;
      this.formatDate();
      this.onModelChange();

      if (!this.changeDetectorRef['destroyed']) {
        this.changeDetectorRef.detectChanges();
      }
    });
    if (this.formGroup !== undefined) {
      const control = this.formGroup.get(this.fieldConfig.name);
      this.editReadOnly = control.disabled;
      this.controlClearSubscription = control.valueChanges.subscribe((value) => {
        if (!value) {
          this.modelDate = null;
          this.modelTime = null;
        }
      });
    }
  }

  formatDate(): void {
    if (this.fieldConfig.dateFormat) {
      this.dateFormat = this.fieldConfig.dateFormat;
    }
    if (!this.data) {
      return;
    }
    this.modelDate = moment(this.data).tz(this.timezone);
    this.modelTime = `${this.modelDate.hours()}:${this.modelDate.minutes()}`;
    if (this.fieldConfig.jsValue) {
      const { entity } = this;
      this.data = eval(this.fieldConfig.jsValue);
      this.formattedDate = moment(this.data).isValid()
        ? moment(this.data).tz(this.timezone).format(this.dateFormat)
        : this.data;
    } else {
      this.formattedDate = moment(this.data).tz(this.timezone).format(this.dateFormat);
    }
    if (this.formGroup && this.modelDate) {
      this.formGroup.get(this.fieldConfig.name).setValue(this.modelDate.format(this.dateFormat));
    }
  }

  onModelChange() {
    if (this.formGroup && this.modelDate) {
      this.formGroup.get(this.fieldConfig.name).setValue(this.modelDate.format(this.saveDateFormat));
    }
  }

  onTimeChange(event) {
    this.modelTime = event;
    const time = event.split(':');
    this.modelDate = this.modelDate.set({
      hour: time[0],
      minute: time[1],
      second: 0,
    });
    this.onModelChange();
  }

  onDateChange($event: any) {
    this.modelTime = '0:0';
    this.modelDate = this.modelDate.set({
      hour: 0,
      minute: 0,
      second: 0,
    });
    this.onModelChange();
  }

  condition(v: UiValidator) {
    const formControl = this.getFormControl();
    const b = !formControl.value || this.getValidatorConfig(v).condition(formControl);
    return b;
  }

  message(v: UiValidator) {
    return this.getValidatorConfig(v).message(v);
  }

  private getValidatorConfig(v: UiValidator): ValidatorConfig {
    return MyErrorStateMatcher.messageMap[v.type];
  }

  private getFormControl(): AbstractControl {
    return this.formGroup.get(this.fieldConfig.name);
  }

  setRowData(entity: any) {
    this.entity = entity;
  }
}
